// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import { anyPass } from "ramda";

export const buildWhatsappLink = ({ phone, text }) => `
  https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(text)}
`;
export const isFastContact = (service) => service === "fast-contact";

export const isWhatsappService = (identifierType) =>
  identifierType === "whatsapp";

export const isCovid = (service) => service === "covid";

export const isSpecialServiceCard = (service) =>
  anyPass([isCovid, isFastContact])(service);
